const users = {
  userManagement: 'User Management',
  users: 'Users',
  user: 'User',
  roles: 'Roles',
  searchUser: 'Search User',
  editUser: 'Edit User',
  createNewUser: 'Create New User',
  name: 'Name',
  email: 'Email',
  phoneNumber: 'Phone Number',
  firstName: 'First Name',
  lastName: 'Last Name',
  answer: 'Answer',
  saveChanges: 'Save Changes',
  confirmUser: 'Confirm User',
  createUser: 'Create User',
  update: 'update',
  admin: 'Admin',
  loginPage: 'Login',
  roleType: {
    SUPER_ADMIN: 'Super Admin',
    AGENT: 'Agent',
    MANAGER: 'Manager',
  },
  active: 'Active',
  blocked: 'Blocked',
  brand: 'Brand',
  brands: 'Brands',
  listBrands: 'List Brands',
  profile: {
    details: 'Personal Information',
    password: 'Password',
    twoFactor: 'Two Factor',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Email',
    brands: 'Brands Assigned',
    resetPassword: 'Reset Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    editProfile: 'Edit profile settings',
  },
  twoFactor: {
    alternativeVerificationCodes: 'Alternative Verification Codes',
    alternativeVerificationSubtitle:
      'Prints a list of codes to log in. Keep these alternate verification codes in a safe place that you can access.',
    finishTwoAuthTitle: 'Finish setting up two-factor authentication',
    setupAuthMessage:
      'Two-factor authentication is enabled for your account. Please enter the code from your authentication app.',
    twoFactorDigits: 'Digits Left',
    twoFactorTitle: 'Two-Factor Authentication',
    twoFactorValidator: 'Please insert only numbers in the fields.',
    twoFactorVerify: 'Verify',
    twoFactorWrongCode: 'Wrong Code',
    twoFactorWrongMessage: 'This code is invalid, please try another code.',
    twoFactorInstructions:
      'Two-factor authentication is enabled for your account. Please enter the code from your authentication app.',
    canYouScanIt: `Click here if you can’t scan the code`,
    codeForPlayer: 'User:',
    configureAuthenticator: 'Configure Authenticator',
    configureAuthenticatorStepOne: '1. Download the Authenticator app',
    configureAuthenticatorStepTwo: '2. Touch <B>Plus Button</B>',
    configureAuthenticatorStepThree: '3. Choose <B>Scan a QR code</B>',
    countAlternativeCodes:
      'You have {{number}} alternative verification codes left',
    desactivationWarning:
      'The deactivation will be notified to the email associated with the account.',
    disableTwoFactor: 'Disable Two-Factor Authentication',
    disableTwoFactorDescription:
      'To deactivate 2FA it is necessary to enter the authentication code. Please enter the code from your authenticator app.',
    downloadCodes: 'Download Codes',
    eachCodeMessage: 'Each alternate verification code can only be used once.',
    enableTwoFactor: 'Enable Two-Factor Authentication',
    keepCodesMessage:
      'Keep these alternate verification codes in a safe place that you can access.',
    noTakeSpaces: 'do not take into account the spaces',
    scanBarcode: `You can't scan the QR code?`,
    scanBarcodeStepOne: '1. Touch <B>Plus Button</B>',
    scanBarcodeStepTwo: '2. Tap <B>Enter a setup key</B>',
    scanBarcodeStepThree:
      '3. Enter your <B>Email Address</B> and this <B>Key</B>',
    scanBarcodeStepFour:
      '4. Make sure the <B>Time Based</B> feature is turned on and tap <B>Add</B> to finish.',
    secretCodes: 'Two Factor Authentication - Backup Codes',
  },
  verficationCode: 'Verification Code',
  currenciesCodes: {
    AED: 'UAE Dirham',
    AFN: 'Afghani',
    ALL: 'Lek',
    AMD: 'Armenian Dram',
    ANG: 'Netherlands Antillean Guilder',
    AOA: 'Kwanza',
    ARS: 'Argentine Peso',
    AUD: 'Australian Dollar',
    AWG: 'Aruban Florin',
    AZN: 'Azerbaijanian Manat',
    BAM: 'Convertible Mark',
    BBD: 'Barbados Dollar',
    BDT: 'Taka',
    BGN: 'Bulgarian Lev',
    BHD: 'Bahraini Dinar',
    BIF: 'Burundi Franc',
    BMD: 'Bermudian Dollar',
    BND: 'Brunei Dollar',
    BOB: 'Boliviano',
    BRL: 'Brazilian Real',
    BSD: 'Bahamian Dollar',
    BTN: 'Ngultrum',
    BWP: 'Pula',
    BYR: 'Belarussian Ruble',
    BZD: 'Belize Dollar',
    CAD: 'Canadian Dollar',
    CDF: 'Congolese Franc',
    CHF: 'Swiss Franc',
    CLP: 'Chilean Peso',
    CNY: 'Yuan Renminbi',
    COP: 'Colombian Peso',
    CRC: 'Costa Rican Colon',
    CUC: 'Peso Convertible',
    CUP: 'Cuban Peso',
    CVE: 'Cabo Verde Escudo',
    CZK: 'Czech Koruna',
    DJF: 'Djibouti Franc',
    DKK: 'Danish Krone',
    DOP: 'Dominican Peso',
    DZD: 'Algerian Dinar',
    EGP: 'Egyptian Pound',
    ERN: 'Nakfa',
    ETB: 'Ethiopian Birr',
    EUR: 'Euro',
    FJD: 'Fiji Dollar',
    FKP: 'Falkland Islands Pound',
    GBP: 'Pound Sterling',
    GEL: 'Lari',
    GGP: 'Guernsey Pound',
    GHS: 'Ghana Cedi',
    GIP: 'Gibraltar Pound',
    GMD: 'Dalasi',
    GNF: 'Guinea Franc',
    GTQ: 'Quetzal',
    GYD: 'Guyana Dollar',
    HKD: 'Hong Kong Dollar',
    HNL: 'Lempira',
    HRK: 'Kuna',
    HTG: 'Gourde',
    HUF: 'Forint',
    IDR: 'Rupiah',
    ILS: 'New Israeli Sheqel',
    IMP: 'Manx Pound',
    INR: 'Indian Rupee',
    IQD: 'Iraqi Dinar',
    IRR: 'Iranian Rial',
    ISK: 'Iceland Krona',
    JEP: 'Jersey Pound',
    JMD: 'Jamaican Dollar',
    JOD: 'Jordanian Dinar',
    JPY: 'Yen',
    KES: 'Kenyan Shilling',
    KGS: 'Som',
    KHR: 'Riel',
    KMF: 'Comoro Franc',
    KPW: 'North Korean Won',
    KRW: 'Won',
    KWD: 'Kuwaiti Dinar',
    KYD: 'Cayman Islands Dollar',
    KZT: 'Tenge',
    LAK: 'Kip',
    LBP: 'Lebanese Pound',
    LKR: 'Sri Lanka Rupee',
    LRD: 'Liberian Dollar',
    LSL: 'Loti',
    LYD: 'Libyan Dinar',
    MAD: 'Moroccan Dirham',
    MDL: 'Moldovan Leu',
    MGA: 'Malagasy Ariary',
    MKD: 'Denar',
    MMK: 'Kyat',
    MNT: 'MNT',
    MOP: 'Tugrik',
    MRO: 'Uguiya',
    MUR: 'Mauritius Rupee	',
    MVR: 'Rufiyaa',
    MWK: 'Kwacha',
    MXN: 'Mexican Peso',
    MYR: 'Malaysian Ringgit',
    MZN: 'Mozambique Metical',
    NAD: 'Namibia Dollar',
    NGN: 'Naira',
    NIO: 'Cordoba Oro',
    NOK: 'Norwegian Krone',
    NPR: 'Nepalese Rupee',
    NZD: 'New Zealand Dollar',
    OMR: 'Rial Omani',
    PAB: 'Balboa',
    PEN: 'Nuevo Sol',
    PGK: 'Kina',
    PHP: 'Philippine Peso',
    PKR: 'Pakistan Rupee',
    PLN: 'Zloty',
    PYG: 'Guarani',
    QAR: 'Qatari Rial',
    RON: 'Romanian Leu',
    RSD: 'Serbian Dinar',
    RUB: 'Russian Ruble',
    RWF: 'Rwanda Franc',
    SAR: 'Saudi Riyal',
    SBD: 'Solomon Islands Dollar',
    SCR: 'Seychelles Rupee',
    SDG: 'Sudanese Pound',
    SEK: 'Swedish Krona',
    SGD: 'Singapore Dollar',
    SHP: 'Saint Helena Pound',
    SLL: 'Leone',
    SOS: 'Somali Shilling',
    SPL: 'Seborgan Luigino',
    SRD: 'Surinam Dollar',
    STD: 'Dobra',
    SVC: 'El Salvador Colon',
    SYP: 'Syrian Pound',
    SZL: 'Lilangeni',
    THB: 'Baht',
    TJS: 'Somoni',
    TMT: 'Turkmenistan New Manat',
    TND: 'Tunisian Dinar',
    TOP: 'Pa’anga',
    TRY: 'Turkish Lira',
    TTD: 'Trinidad and Tobago Dollar',
    TVD: 'Tuvaluan Dollar',
    TWD: 'New Taiwan Dollar',
    TZS: 'Tanzanian Shilling',
    UAH: 'Hryvnia',
    UGX: 'Uganda Shilling',
    USD: 'US Dollar',
    USDT: 'USDT',
    UYU: 'Peso Uruguayo',
    UZS: 'Uzbekistan Sum',
    VEF: 'Bolivar',
    VES: 'Bolivar',
    VND: 'Dong',
    VUV: 'Vatu',
    WST: 'Tala',
    XAF: 'CFA Franc BEAC',
    XAG: 'Silver Ounces',
    XAU: 'Gold Ounces',
    XBT: 'Bitcoin', // This is right: XBT is also used. It starts with an X in accordance with the ISO4217
    XCD: 'East Caribbean Dollar',
    XDR: 'SDR (Special Drawing Right)',
    XOF: 'CFA Franc BCEAO',
    XPD: 'Palladium Ounces',
    XPF: 'CFP Franc',
    XPT: 'Platinum Ounces',
    YER: 'Yemeni Rial',
    ZAR: 'Rand',
    ZMW: 'Zambian Kwacha',
    ZWD: 'Zimbabwe Dollar',
  },
}

export default users
